import { initWebSocket, SOCKET } from "./initWebSocket";
import webSocketApiService from "./wsApiServices";


{/** Starts a conversation via socket with provided user and bot parameters.*/ }
export const startConversation = (userId, { conversationId = "", botId = "" }) => {
    const conversation = {
        conversationId,
        bot: botId,
        participants: [userId],
        onChannels: [],
        closed: false,
    };

    const messagePayload = {
        messageType: "init",
        message: {
            intentId: "main",
            OsVersion: "",
            brand: "",
            model: "",
            platform: "",
            userAgent: "",
        },
    };

    socketSendMessageFirstEvent(messagePayload, conversation);
};

{/** Emits another events to the socket.*/ }
export async function socketSendMessageEvent(req) {
  const ws = SOCKET.ws;

  if (!ws || ws.readyState !== WebSocket.OPEN) {
    try {
      console.log("socketSendMessageEvent: WebSocket not open, attempting reconnect...");
      await initWebSocket();
      ws = SOCKET.ws;
      console.log("socketSendMessageEvent: reconnect attempt finished", ws);
    } catch (e) {
      console.error("socketSendMessageEvent: reconnect failed", e);
    }
  }
  
  if (!ws || ws.readyState !== WebSocket.OPEN) {
    return Promise.reject("WebSocket not connected");
  }

  console.log("%c Sending messages by user to socket :", "color: green;", req)
  return new Promise((resolve, reject) => {
    SOCKET.pendingRequests[req.requestId] = { resolve, reject };
    ws.send(JSON.stringify(req));
  });
};

{/** Emits another events to the socket.*/ }
export const socketSendMessageFirstEvent = async(parametersData, conversation) => {

    const payload = {
        capability: "BackendBotCap",
        parameters: JSON.stringify({
            "command": "sendMessage",
            "botId": conversation?.bot,
            "data": parametersData,
        }),
        sync: false,
        conversation
    };
    await webSocketApiService.AgentGuardService(payload)
};

export const socketSendMessageAnotherEvent = async(parametersData, conversation) => {

    const payload = {
        capability: "BackendBotCap",
        parameters: JSON.stringify({
            "command": "sendMessage",
            "botId": conversation?.bot,
            "data": parametersData,
        }),
        sync: false,
        conversation: {
            conversationId: conversation?.conversationId,
            bot: conversation?.bot,
        },
    };
    await webSocketApiService.AgentGuardService(payload)
};
